import { render } from "./RiddleCard.vue?vue&type=template&id=55634109"
import script from "./RiddleCard.vue?vue&type=script&lang=js"
export * from "./RiddleCard.vue?vue&type=script&lang=js"

import "@/styles/RiddleCard.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__